import React from 'react';
import * as styles from './MainHeadline.module.scss';
import cn from "classnames";

const MainHeadline = ({
  featuredEmoji = "🛀",
  headline = "As We May Think",
  description = "This is Fibery's radically honest blog. You'll find deep and shallow thoughts about augmenting intelligence, products, and tools.",
  backLink = false
}) => {
  return (
    <div className={styles.root}>
      <div className={styles.contentSide}>
        {backLink ? (
          <a href={"https://fibery.io/blog/"} className={cn(styles.backButton)}>
            <span>Radically Honest Blog</span>
          </a>
        ) : null}
        <div className={styles.headlineWrap}>
          <h1 className={styles.mainHeadline}>{headline}</h1>
          <div className={styles.featuredEmoji}>{featuredEmoji}</div>
        </div>
        <p className={styles.descriptionWrap}>{description}</p>
      </div>
    </div>
  )
};

export default MainHeadline;
